export const ScrollToRef = (ref: React.RefObject<HTMLDivElement>) => {
   if (ref && ref.current) {
      const offsetTop = ref.current.offsetTop;
      window.scrollTo({
         top: offsetTop,
         behavior: "smooth",
      });
   }
};
